import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateRangePicker = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChange = ([start, end]) => {
    setStartDate(start);
    setEndDate(end);
    if (onDateChange) {
      onDateChange(start, end);
    }
  };

  return (
    <div>
      <div>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={handleChange}
          isClearable
          placeholderText="Select a date range"
          dateFormat="dd.MM.yyyy"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
